import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';
import { useFeatureFlagVariantKey } from 'posthog-js/react';
import { ButtonContained } from '@/UI/Buttons/AppButton';
import { ShareIcon } from '@/UI/Icons/ShareIcon';
import { I18N_KEYS } from '@/language/keys';
import { useSubscriptionPermissions } from '@/hooks/useSubscriptionPermissions/useSubscriptionPermissions';
import { SubscriptionType } from '@/types/shared';
import { FF_DISABLE_SHARE_FOR_FREE_USERS, FF_DISABLE_SHARE_FOR_FREE_USERS_VARIANT_TEST } from '@/consts/featureFlags';
import { useAnalytics, TrackTypeEnum } from '@/hooks/useAnalytics';
import ShareWorkflowModal from './ShareWorkflowModal';

export function ShareWorkflowButtonWithModal() {
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const { isSubscriptionTypeIn } = useSubscriptionPermissions();
  const disableShareExperimentVariant = useFeatureFlagVariantKey(FF_DISABLE_SHARE_FOR_FREE_USERS);
  const isSharingDisabled =
    disableShareExperimentVariant === FF_DISABLE_SHARE_FOR_FREE_USERS_VARIANT_TEST &&
    isSubscriptionTypeIn([SubscriptionType.Free]);

  const { t } = useTranslation();
  const { track } = useAnalytics();

  const handleShare = () => {
    track('shared_workflow_modal_open', {}, TrackTypeEnum.BI);
    setIsShareModalOpen(true);
  };

  return (
    <>
      <Tooltip title={isSharingDisabled ? t(I18N_KEYS.SHARE_WORKFLOW_MODAL.FREE_PLAN_TOOLTIP) : ''} placement="top">
        <span>
          <ButtonContained
            onClick={handleShare}
            startIcon={<ShareIcon width={16} height={16} />}
            size="xs"
            mode="filled-light-secondary"
            disabled={isSharingDisabled}
          >
            {t(I18N_KEYS.RECIPE_MAIN.FLOW.SHARE)}
          </ButtonContained>
        </span>
      </Tooltip>
      {isShareModalOpen && <ShareWorkflowModal open={isShareModalOpen} onClose={() => setIsShareModalOpen(false)} />}
    </>
  );
}
